import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "mt-2 fw-bold" }
const _hoisted_4 = { class: "d-flex justify-content-around mt-2" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-magenta" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-magenta" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-magenta" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = { class: "text-center mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_network = _resolveComponent("icon-network")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_icon_network)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "La tua rete",
          text: "La tua rete"
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Lo stato degli utenti nella tua rete",
          text: "Lo stato degli utenti nella tua rete"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Invitati:",
            text: "Invitati:"
          })
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.firstLineTotal) + " ", 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Diretti:",
            text: "Diretti:"
          })
        ]),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.firstLineActive) + " ", 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Rete:",
            text: "Rete:"
          })
        ]),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.descendantsActive) + " ", 1)
      ])
    ]),
    (_ctx.$route.fullPath != '/network/network')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/network/network')))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Vedi rete",
                text: "Vedi rete"
              })
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}